<template>
  <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 0H0L4.58579 4.58579C5.36684 5.36684 6.63317 5.36683 7.41421 4.58579L12 0Z"/>
  </svg>
</template>

<script>
export default {
  name: 'triangle'
}
</script>

<style lang="stylus" scoped>
path {
  fill: var(--color-triangle, var(--B0-t-overlay))
}
</style>
